export default __webpack_public_path__ + "static/media/nax.3a615f7c.png";